import * as v from 'valibot';
import type { FieldDefinition } from '@v2/components/SchemaForm/types';

export const createPimsSchema = v.object({
  name: v.pipe(v.string(), v.minLength(1, 'Name is required')),
  supportsConnectivity: v.optional(v.boolean(), false),
  appId: v.pipe(v.string(), v.minLength(1, 'App is required')),
});

export type CreatePimsFormValues = v.InferOutput<typeof createPimsSchema>;

export const createPimsFields: FieldDefinition[] = [
  { name: 'name', label: 'Name', type: 'text', placeholder: 'Enter PIMS name' },
  { name: 'appId', label: 'App', type: 'select', placeholder: 'Select an app', options: [] },
];
